/**
 * useProfileVideo Hook
 * Custom hook for fetching the user's profile video
 */

import { useQuery } from "@tanstack/react-query"
import apiClient from "@/lib/api-client"

async function getProfileVideo(userId: string) {
  const { data } = await apiClient.get(`api/profiles/${userId}/videos`)
  return data.data.video
}

export function useProfileVideo(userId: string) {
  return useQuery({
    queryKey: ["video", userId],
    queryFn: () => getProfileVideo(userId),
    enabled: !!userId,
  })
}
